// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__RJ-NW","image":"Header_image__odh84","name":"Header_name__2BPaU","info":"Header_info__3SLiT","infoRow":"Header_infoRow__2uNfy"};